import { INPUT_TYPES } from '../utils/constants.js';
export default {
    title: 'Three dimensional scene Play Button on thumbnails',
    isRelevant: () => true,
    isRelevantDescription: 'Always relevant.',
    type: INPUT_TYPES.BOOLEAN,
    default: false,
    description: `Show three dimensional scene play button on thumbnails in a thumbnail gallery`,
};
//# sourceMappingURL=behaviourParams_item_threeDimensionalScene_enableThumbnailsPlayButton.js.map